// Additive scroll-lock fix for <cart-drawer>: the vendor script (main.js)
// only adds/removes 'overflow-hidden' on document.body when the drawer
// opens/closes, never on document.documentElement. Once the page already
// has a non-zero scroll position, locking body alone doesn't stop wheel/
// touch scroll from moving the page underneath the drawer. The
// harness-buy-box modal doesn't have this problem because its own
// openModal()/closeModal() already toggle 'overflow-hidden' on BOTH html
// and body — this mirrors that same pattern for the cart-drawer, without
// touching the vendor script or the drawer's own open()/close() methods.
document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  var wasActive = cartDrawer.classList.contains('active');

  function syncHtmlOverflowLock() {
    var isActive = cartDrawer.classList.contains('active');
    if (isActive === wasActive) return;
    wasActive = isActive;
    document.documentElement.classList.toggle('overflow-hidden', isActive);
  }

  new MutationObserver(syncHtmlOverflowLock).observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class'],
  });
});
